module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.noLiSurround) ? _c('ul', {
    class: _vm.containerClass
  }, [_c('li', {
    class: [_vm.prevClass, _vm.firstPageSelected() ? _vm.disabledClass : '']
  }, [_c('a', {
    class: _vm.prevLinkClass,
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.prevPage()
      }
    }
  }, [_vm._t("prevContent", function() {
    return [_vm._v(_vm._s(_vm.prevText))]
  })], 2)]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      class: [_vm.pageClass, page.selected ? _vm.activeClass : '', page.disabled ? _vm.disabledClass : '']
    }, [(page.disabled) ? _c('a', {
      class: _vm.pageLinkClass,
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(page.content))]) : _c('a', {
      class: _vm.pageLinkClass,
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.handlePageSelected(page.index)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handlePageSelected(page.index)
        }
      }
    }, [_vm._v(_vm._s(page.content))])])
  }), _vm._v(" "), _c('li', {
    class: [_vm.nextClass, _vm.lastPageSelected() ? _vm.disabledClass : '']
  }, [_c('a', {
    class: _vm.nextLinkClass,
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.nextPage()
      }
    }
  }, [_vm._t("nextContent", function() {
    return [_vm._v(_vm._s(_vm.nextText))]
  })], 2)])], 2) : _c('div', {
    class: _vm.containerClass
  }, [_c('a', {
    class: [_vm.prevLinkClass, _vm.firstPageSelected() ? _vm.disabledClass : ''],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.prevPage()
      }
    }
  }, [_vm._t("prevContent", function() {
    return [_vm._v(_vm._s(_vm.prevText))]
  })], 2), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return [(page.disabled) ? _c('a', {
      class: [_vm.pageLinkClass, page.selected ? _vm.activeClass : '', page.disabled ? _vm.disabledClass : ''],
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v("\n            " + _vm._s(page.content))]) : _c('a', {
      class: [_vm.pageLinkClass, page.selected ? _vm.activeClass : '', page.disabled ? _vm.disabledClass : ''],
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.handlePageSelected(page.index)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handlePageSelected(page.index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page.content) + "\n        ")])]
  }), _vm._v(" "), _c('a', {
    class: [_vm.nextLinkClass, _vm.lastPageSelected() ? _vm.disabledClass : ''],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.nextPage()
      }
    }
  }, [_vm._t("nextContent", function() {
    return [_vm._v(_vm._s(_vm.nextText))]
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e32d6d2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 1748
// module chunks = 1